import { render, staticRenderFns } from "./IsBlockedColumnType.vue?vue&type=template&id=57d48d7e&scoped=true&"
import script from "./IsBlockedColumnType.vue?vue&type=script&lang=js&"
export * from "./IsBlockedColumnType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d48d7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
